import { instance } from "libs/api";

import { ApiRoutesDrivers } from "./../../constants";
import {
  CreateDriverRequestBody,
  CreateDriverResponseData
} from "./createDriver.types";

export const requestCreateDriver = async (
  body: CreateDriverRequestBody
): Promise<CreateDriverResponseData> => {
  return await instance.post(ApiRoutesDrivers.Drivers, body);
};
